/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_FramedInputs */

const en_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Framed?`)
};

const es_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Enmarcado?`)
};

const fr_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadré ?`)
};

const de_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerahmt?`)
};

const ja_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`額装の有無`)
};

const zh_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否已装裱？`)
};

const ar_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مؤطر؟`)
};

const id_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibingkai?`)
};

const it_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Cornice?`)
};

const ru_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В раме?`)
};

const pt_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emoldurado?`)
};

const ko_field_framed = /** @type {(inputs: Field_FramedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`액자 포함 여부`)
};

/**
* | output |
* | --- |
* | "Framed?" |
*
* @param {Field_FramedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_framed = /** @type {((inputs?: Field_FramedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_FramedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_framed(inputs)
	if (locale === "es") return es_field_framed(inputs)
	if (locale === "fr") return fr_field_framed(inputs)
	if (locale === "de") return de_field_framed(inputs)
	if (locale === "ja") return ja_field_framed(inputs)
	if (locale === "zh") return zh_field_framed(inputs)
	if (locale === "ar") return ar_field_framed(inputs)
	if (locale === "id") return id_field_framed(inputs)
	if (locale === "it") return it_field_framed(inputs)
	if (locale === "ru") return ru_field_framed(inputs)
	if (locale === "pt") return pt_field_framed(inputs)
	return ko_field_framed(inputs)
});